import React, { useEffect, useState, useRef } from "react";
import { productdetails1, productdetails2, productdetails3 } from "../imgUrl";
import { useParams, useNavigate, Link } from "react-router-dom";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Cookies from "js-cookie";
import axios from "axios";
import { fetchProductDetails } from "../features/feature1/feature1API";
import Spinner from "react-bootstrap/Spinner";
import { toast } from "react-toastify";

const API_URL = `${process.env.REACT_APP_API_URL}`; // Replace with your actual API URL

const ProductDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [quantity, setQuantity] = useState(1);

  const thumbnailRef = useRef(null);

  const fetchDiscountDetails = async (discountedId) => {
    try {
      const response = await axios.get(`${API_URL}/discounts/${discountedId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching discount details:", error);
      return null;
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await fetchProductDetails(id);
        const productData = response.data;
        // Fetch discount details for each variant
        const variantsWithDiscount = await Promise.all(
          productData.variants.map(async (variant) => {
            if (variant.discounted_id) {
              const discountDetails = await fetchDiscountDetails(
                variant.discounted_id
              );
              return {
                ...variant,
                discountDetails,
              };
            }
            return variant;
          })
        );
        setData({ ...productData, variants: variantsWithDiscount });
        setSelectedVariant(variantsWithDiscount.find((v) => v.inStock)); // Select the first in-stock variant
        setLoading(false);
      } catch (error) {
        setError("Error fetching product details");
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const handleVariantChange = (variant) => {
    if (variant.inStock) {
      setSelectedVariant(variant);
      setQuantity(1);
    } else {
      toast.error("This variant is out of stock.");
    }
  };

  const calculateDiscountedPrice = (variant) => {
    if (!variant.discountDetails) return variant.price;

    const { discount, discount_type } = variant.discountDetails;

    if (discount_type === "perc") {
      return variant.price * (1 - discount / 100);
    } else if (discount_type === "fixed") {
      return Math.max(0, variant.price - discount);
    }

    return variant.price;
  };

  const handleThumbnailClick = (index) => {
    setCurrentSlide(index);
  };

  const scrollThumbnails = (direction) => {
    if (thumbnailRef.current) {
      const scrollAmount = direction === "up" ? -100 : 100;
      thumbnailRef.current.scrollBy({ top: scrollAmount, behavior: "smooth" });
    }
  };

  // const today = new Date();

  // // Format date as "26 August, 2024"
  // const options = { day: '2-digit', month: 'long', year: 'numeric' };
  // const formattedDate = today.toLocaleDateString('en-GB', options);

  // const handleVariantChange = (variant) => {
  //   setSelectedVariant(variant);
  //   setQuantity(1);
  // };

  const handleQuantityChange = (e) => {
    setQuantity(parseInt(e.target.value));
  };

  const addToCart = () => {
    if (!selectedVariant) return;

    const discountedPrice = calculateDiscountedPrice(selectedVariant);
    const cartItem = {
      id: data._id,
      title: data.title,
      variant: selectedVariant,
      quantity: quantity,
      price: discountedPrice * quantity,
      originalPrice: selectedVariant.price * quantity,
      image: data.media && data.media.length > 0 ? data.media[0].url : null,
      media_id: data.media && data.media.length > 0 ? data.media[0]._id : null,
      discount_id: selectedVariant.discountDetails
        ? selectedVariant.discountDetails._id
        : null,
    };

    const currentCart = Cookies.get("cart")
      ? JSON.parse(Cookies.get("cart"))
      : [];
    const existingItemIndex = currentCart.findIndex(
      (item) =>
        item.id === cartItem.id && item.variant._id === cartItem.variant._id
    );

    if (existingItemIndex > -1) {
      currentCart[existingItemIndex].quantity += cartItem.quantity;
      currentCart[existingItemIndex].price += cartItem.price;
    } else {
      currentCart.push(cartItem);
    }

    Cookies.set("cart", JSON.stringify(currentCart), { expires: 7 });
    toast.success("Product added to cart!");
    navigate("/cartpage");
  };
  const buyNow = () => {
    addToCart();
    navigate("/cart");
  };

  if (loading)
    return (
      <div className="text-center">
        <Spinner animation="border" role="status">
          <span className="sr-only"></span>
        </Spinner>
      </div>
    );
  if (error) return <div>{error}</div>;
  if (!data) return null;

  if (loading)
    return (
      <div>
        <Spinner animation="border" role="status">
          <span className="sr-only"></span>
        </Spinner>
      </div>
    );
  if (error) return <div>{error}</div>;

  return (
    <div className="pb-5">
      <div className="section_produc_detailsl">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="home">
                <ul className="home1">
                  <li>
                    <a href="/">
                      Home
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={8}
                        height={15}
                        viewBox="0 0 8 15"
                        fill="none"
                      >
                        <path
                          d="M1.53249 4.11249L2.19562 3.45L5.80749 7.06062C5.86571 7.11847 5.91192 7.18727 5.94345 7.26305C5.97498 7.33883 5.99121 7.4201 5.99121 7.50218C5.99121 7.58426 5.97498 7.66553 5.94345 7.74131C5.91192 7.81709 5.86571 7.88589 5.80749 7.94374L2.19562 11.5562L1.53312 10.8937L4.92312 7.50312L1.53249 4.11249Z"
                          fill="black"
                        />
                      </svg>
                    </a>
                  </li>
                  <li>
                    <Link href="">{data.title}</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div
                className="product-image-carousel d-flex product-form"
                style={{ position: "relative" }}
              >
                <div style={{ width: "80%" }}>
                  <Carousel
                    selectedItem={currentSlide}
                    onChange={setCurrentSlide}
                    showArrows={true}
                    showStatus={true}
                    showIndicators={true}
                    showThumbs={true}
                    useKeyboardArrows={true}
                    swipeable={true}
                    emulateTouch={true}
                  >
                    {data.media &&
                      data.media.map((image) => (
                        <div key={image._id}>
                          <img
                            src={image.url}
                            alt={`Product image ${image._id}`}
                          />
                        </div>
                      ))}
                  </Carousel>
                </div>
              </div>

              {/* ... (brand icon section remains the same) ... */}

              <div className="brand-icon">
                <ul className="brand_box">
                  <li>
                    <img src={productdetails1} />
                    <h4>Secure Payment</h4>
                  </li>
                  <li>
                    <img src={productdetails2} />
                    <h4>Trusted Pharmacy</h4>
                  </li>
                  <li>
                    <img src={productdetails3} />
                    <h4>Genuine Products</h4>
                  </li>
                </ul>
              </div>

              {/* ... (brand icon section remains the same) ... */}
            </div>

            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div className="product_details">
                <h3>{data.title}</h3>
                {selectedVariant && (
                  <ul className="inner-main">
                    <li className="inner-sub">
                      <h3 className="sub">
                        MRP: ₹
                        {calculateDiscountedPrice(selectedVariant).toFixed(2)}*{" "}
                        <del>MRP ₹{selectedVariant.price.toFixed(2)}</del>
                      </h3>
                    </li>
                    <li className="inner-duv">
                      <h3 className="sub">
                        {selectedVariant.discountDetails
                          ? selectedVariant.discountDetails.discount_type ===
                            "perc"
                            ? `${selectedVariant.discountDetails.discount}% off`
                            : `₹${selectedVariant.discountDetails.discount} off`
                          : "No discount"}
                      </h3>
                    </li>
                  </ul>
                )}
                <div className="Delivery">
                  <ul className="inner_second">
                    <li className="svg_img">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={20}
                        height={20}
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M1 19H10.9C11.9637 19 13.017 18.7905 13.9997 18.3834C14.9825 17.9764 15.8754 17.3797 16.6276 16.6276C17.3797 15.8754 17.9764 14.9825 18.3834 13.9997C18.7905 13.017 19 11.9637 19 10.9C19 9.8363 18.7905 8.783 18.3834 7.80027C17.9764 6.81753 17.3797 5.92459 16.6276 5.17244C15.8754 4.42028 14.9825 3.82364 13.9997 3.41658C13.017 3.00952 11.9637 2.8 10.9 2.8C6.7303 2.8 3.2473 5.95 2.8 10M15.85 4.15L16.75 3.25M4.15 3.25L5.05 4.15"
                          stroke="black"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M14.05 7.3L11.404 9.946C11.2795 9.81706 11.1305 9.71422 10.9658 9.64346C10.8011 9.57271 10.6239 9.53547 10.4447 9.53391C10.2654 9.53235 10.0877 9.56651 9.92176 9.63439C9.75585 9.70227 9.60512 9.80251 9.47837 9.92927C9.35161 10.056 9.25137 10.2068 9.18349 10.3727C9.11561 10.5386 9.08145 10.7163 9.08301 10.8956C9.08457 11.0748 9.12181 11.252 9.19256 11.4167C9.26332 11.5814 9.36616 11.7304 9.4951 11.8549C9.74836 12.1082 10.0918 12.2504 10.45 12.2504C10.8082 12.2504 11.1516 12.1082 11.4049 11.8549C11.6582 11.6016 11.8004 11.2582 11.8004 10.9C11.8004 10.5418 11.6582 10.1984 11.4049 9.9451M10.45 2.35V1M8.65 1H12.25M1 12.7H3.7M1 16.3H5.5"
                          stroke="black"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </li>
                    <li className="">Delivery By</li>
                    <li className="date">26 August, 2024</li>
                    {/* <li className="">Delivery By</li>
      <li className="date">{formattedDate}</li> */}
                  </ul>
                </div>
                <div className="button_div">
                  <button className="btn_cart" onClick={addToCart}>
                    Add to Cart
                  </button>
                  <button className="buy" onClick={buyNow}>
                    Buy Now
                  </button>
                </div>
                <br />
                <div>
                  Selected Pack Size:{" "}
                  {selectedVariant ? selectedVariant.size : ""}
                </div>
                <div className="containerr">
                  {data.variants &&
                    data.variants.map((variant) => (
                      <>
                        <div
                          className={`box ${
                            selectedVariant &&
                            selectedVariant._id === variant._id &&
                            selectedVariant.inStock === variant.inStock
                              ? "selected"
                              : ""
                          } ${!variant.inStock ? "outofstck" : ""}`} // Add 'outofstck' class if not in stock
                          key={variant._id}
                          onClick={() =>
                            variant.inStock && handleVariantChange(variant)
                          } // Disable click if out of stock
                          style={{
                            pointerEvents: variant.inStock ? "auto" : "none",
                            opacity: variant.inStock ? 1 : 0.5,
                          }} // Visually disable the box
                        >
                          <span className="thund">{variant.size}</span>
                          <label className="radio-label">
                            <input
                              type="radio"
                              name="variant"
                              checked={
                                selectedVariant &&
                                selectedVariant._id === variant._id
                              }
                              onChange={() => handleVariantChange(variant)}
                              disabled={!variant.inStock} // Disable the radio input if out of stock
                            />
                            <span className="mny">
                              ₹{calculateDiscountedPrice(variant).toFixed(2)}
                            </span>
                            <p className="mb-0">
                              (₹
                              {(
                                calculateDiscountedPrice(variant) /
                                parseInt(variant.size)
                              ).toFixed(2)}{" "}
                              / 1 ml){" "}
                            </p>

                            <span className="stock-status">
                              {" "}
                              {variant.inStock ? "In Stock" : "Out of Stock"}
                            </span>
                          </label>
                        </div>
                      </>
                    ))}
                </div>
                <div className="slect">
                  <select
                    name=""
                    className="arrow"
                    onChange={(e) => handleQuantityChange(e)}
                    value={quantity}
                  >
                    {[...Array(10)].map((_, i) => (
                      <option key={i} value={i + 1}>
                        {i + 1} {data.title} (
                        {selectedVariant ? selectedVariant.size : ""})
                      </option>
                    ))}
                  </select>
                </div>
                <div className="inner_last">
                  <ul className="last_content">
                    <li className="manter">Manufacturer/Marketer</li>
                    <li className="johnplt">
                      {" "}
                      {data?.brand_id?.name || "Brand not available"}
                    </li>
                  </ul>
                  <ul className="chery">
                    <li className="contype">Consume Type</li>
                    <li className="top">
                      {data?.consume_type || "Consume Type not available"}
                    </li>
                  </ul>
                  <ul className="info">
                    <li className="rplcy">Return Policy</li>
                    <li className="nonturn">Not Returnable</li>
                  </ul>
                  <ul className="num_py">
                    <li className="expo">Expires on or after</li>
                    <li className="datesa">
                      {data?.expiry_date || "Expires not available"}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 col-xs-12">
              <div className="product_detal">
                <h1 className="lorem">Product Details</h1>
                <h2 className="epsum">Key Ingredients</h2>
                <p className="chemicals">{data.description}</p>
              </div>
            </div>
            <div className="col-lg-8 col-md-8 col-sm-8 col-12 col-xs-12">
              <div className="Manufacturer">
                <h1 className="manufature_heading">From the Manufacturer</h1>
                {data.brochure && data.brochure.length > 0 && (
                  <img
                    src={data.brochure[0].url}
                    alt="Brochure"
                    className="manufacturer-image"
                  />
                )}
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-4 col-12 col-xs-12">
              <div className="blank" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetails;
